import { ws } from "../../../utils/common";

export const verifyAccountWS = async ({ id }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user-verification/" + id,
    null,
    false
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
